import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = [
  "SBA LOANS",
  "BUSINESS LINE OF CREDIT",
  "REVENUE FINANCING",
  "EQUIPMENT FINANCING",
  "WORKING CAPITAL",
  "MERCHANT CASH ADVANCE",
  "TERM LOANS",
  "BRIDGE LOANS",
  "STARTUP FINANCING",
  "FIX & FLIP",
  "PURCHASE ORDER",
  "ACCOUNTS RECEIVABLE",
  "FRANCHISE FINANCING",
  "RESIDENTIAL INVESTMENT",
];

export const EditorialMarquee = () => (
  <section
    aria-label="Products offered"
    className="border-y border-black/10 bg-[color:var(--bg)] py-6 overflow-hidden"
  >
    <Marquee speed={38} gradient={false} pauseOnHover>
      {WORDS.map((w, i) => (
        <span
          key={`${w}-${i}`}
          className="marquee-item font-mono text-[color:var(--bone)]/85 text-sm md:text-base tracking-[0.28em] uppercase"
        >
          {w}
        </span>
      ))}
    </Marquee>
  </section>
);

export default EditorialMarquee;
